import { render, staticRenderFns } from "./UrgencyWaitingRoom.vue?vue&type=template&id=72c4c6c3&scoped=true&lang=pug"
import script from "./UrgencyWaitingRoom.vue?vue&type=script&lang=js"
export * from "./UrgencyWaitingRoom.vue?vue&type=script&lang=js"
import style0 from "./UrgencyWaitingRoom.vue?vue&type=style&index=0&id=72c4c6c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c4c6c3",
  null
  
)

export default component.exports